/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useRef, useState } from "react";
import { Button, Card, Form, Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import { monthResources, resetMonthResources } from "../actions/proyects.actions";
import MonthResourceCard from "./MonthResourceCard";

const options = [
  {
    title: 'Volver',
    optionNumber: 0,
  }, {
    title: 'Recursos del período',
    optionNumber: 1,
  }, 
  {
    title: 'Recursos acumulado',
    optionNumber: 2,
  },
];


const ResourceList = ({ resources, loading, hasMore, loadMore, totalItems, currentPage, onSearch, accumulated, head }) => {
  const observer = useRef();
  const lastResourceRef = useCallback(node => {
    if (loading || !hasMore) return;
    if (observer.current) observer.current.disconnect();
    
    observer.current = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting && hasMore) {
        loadMore();
      }
    });
    
    if (node) observer.current.observe(node);
  }, [loading, hasMore]);

  console.log('resources', resources[0])

  return (
    <div className="mt-3">
      <Card className="mb-3">
        <Card.Body>
          <Row className="align-items-center">
            <Col md={6}>
              <Form.Control 
                type="text" 
                placeholder="Buscar recurso..." 
                onChange={(e) => onSearch(e.target.value)}
              />
            </Col>
            <Col md={6} className="text-right">
              <span className="text-muted">
                Mostrando {resources.length} de {totalItems} recursos - Página {currentPage}
              </span>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {resources.map((resource, index) => {
        if (index === resources.length - 1) {
          return (
            <div ref={lastResourceRef} key={index}>
              <MonthResourceCard data={resource} accumulated={accumulated}/>
            </div>
          );
        }
        return <MonthResourceCard key={index} data={resource} accumulated={accumulated}/>;
      })}

      {loading && (
        <div className="text-center my-3">Cargando más recursos...</div>
      )}

      {!hasMore && resources.length > 0 && (
        <div className="text-center my-3">No hay más recursos para mostrar</div>
      )}
    </div>
  );
};

const CardsHistory = ({head}) => {
	const location = useLocation();
	const dispatch = useDispatch();
	const typeUrl = location.pathname.split("/")[3];
	const codPCGUrl = location.pathname.split("/")[4] || '';
	const proyects = useSelector((state) => state.proyects);
	const auth = useSelector(state => state.auth);
	
	const [loading, setLoading] = useState(true);
	const [selectedOption, setSelectedOption] = useState(0);

	const [selectedData, setSelectedData] = useState({});
	const [searchTerm, setSearchTerm] = useState('');
	// const [currentPage, setCurrentPage] = useState(1);
	const searchTimeoutRef = useRef(null);
	const currentPageRef = useRef(1);
	const accumulatedRef = useRef(0);
	


	// Obtener datos de recursos del estado Redux
	const resourcesData = proyects.monthResources || {};
	const totalItems = resourcesData.totalItems || 0;
	
	const hasMore = proyects.monthResources.items.length < totalItems;

	useEffect(() => {
		setLoading(false);
	}, [proyects.listHistory]);

	const loadMoreResources = () => {
		if (selectedOption > 0 && selectedData.CodPeriodo && hasMore) {
			const page = currentPageRef.current + 1;
			currentPageRef.current = page;
			console.log('loadMoreResources', page)
			monthResources(
				selectedData.CodProyecto,
				typeUrl,
				codPCGUrl,
				searchTerm,
				page,
				accumulatedRef.current, 
				auth.scaleSelected, 
				auth.dateSelected,
				head
			);
		}
	};

	const handleSearch = (term) => {
		
		if (searchTimeoutRef.current) {
		clearTimeout(searchTimeoutRef.current);
		}
		
		searchTimeoutRef.current = setTimeout(() => {
		setSearchTerm(term);
		currentPageRef.current = 1;
		dispatch(resetMonthResources());
		monthResources(
			selectedData.CodProyecto,
			typeUrl,
			codPCGUrl,
			term,
			1,
			accumulatedRef.current, 
			auth.scaleSelected, 
			auth.dateSelected
		);
		}, 500);
	};

	const handleOptionClick = async (option, data) => {
		dispatch(resetMonthResources());
		setSelectedData(data);
		setSelectedOption(option.optionNumber);
		setSearchTerm('');
		accumulatedRef.current = option.optionNumber === 2 ? 1 : 0;
		currentPageRef.current = 1; 
		
		if (option.optionNumber > 0) {
			monthResources(
				data.CodProyecto,
				typeUrl,
				codPCGUrl,
				'',
				1,
				option.optionNumber === 2 ? 1 : 0, 
				auth.scaleSelected, 
				auth.dateSelected,
				head,
			);
		}
	};

	return (
		<>
		{loading ? 'Cargando...' : (
			<>
			{proyects.listHistory
				.filter(d => selectedOption === 0 || d.CodPeriodo === selectedData.CodPeriodo)
				.map((data, index) => (
				<div key={index}>
					<Card className="w-100 mb-3">
					<Card.Body className="p-1">
						<div className="d-flex justify-content-around align-items-center">
						<Card.Text className="mb-1">
							{data.Periodo}
						</Card.Text>
						{options.filter(o => o.optionNumber !== selectedOption).map(option => (
							<Card.Text className="mb-1" key={option.optionNumber}>
							<Button 
								variant="outline-primary" 
								size="sm" 
								className="my-2"
								onClick={() => handleOptionClick(option, data)}
							>
								{option.title}
							</Button>
							</Card.Text>
						))}
						</div>

						
						<div className="d-flex justify-content-around">
							<div>
								<Card.Text className="d-flex align-items-center mb-1">
									<div
										className="bg-blue card-h5 mr-2 d-flex"
										style={{
											width: 10,
											height: 10,
											borderRadius: "50%",
										}}
									></div>
									Programado
								</Card.Text>
								<p className="mb-1 text-right"> {Intl.NumberFormat("en").format(data.M_ProgramadoValorizado)}</p>

								<p className="mb-1 text-right"> {data.PorcentajeProgramado}%</p>
								
								<p className="mb-1 text-right">{ Intl.NumberFormat("en").format(data.M_ProgramadoValorizadoAcumulado)}</p>
								<p className="mb-1 text-right">{ data.PorcentajeProgramadoAcumulado}%</p>
							</div>
		
							<div>
								<Card.Text className="d-flex align-items-center mb-1">
									<div
										className="bg-yellow card-h5 mr-2 "
										style={{
											width: 10,
											height: 10,
											borderRadius: "50%",
										}}
									></div>
									Valorizado
								</Card.Text>
								<p className={`mb-1 ${data.PorcentajeFA < 0 ? 'text-danger' : 'text-success'} text-right`}>
									{ Intl.NumberFormat("en").format(data.M_ValorizadoValorizado)}
								</p>

								<p className={`mb-1 ${data.PorcentajeFA < 0 ? 'text-danger' : 'text-success'} text-right`}>
									{data.PorcentajeValorizado}%
								</p>

								<p className={`mb-1 ${data.PorcentajeFAAcumulado < 0 ? 'text-danger' : 'text-success'} text-right`}>
									{Intl.NumberFormat("en").format(data.M_ValorizadoValorizadoAcumulado) }
								</p>
								
								<div className={`mb-1 ${data.PorcentajeFAAcumulado < 0 ? 'text-danger' : 'text-success'} text-right`}>
									{data.PorcentajeValorizadoAcumulado}%
								</div>
								
							</div>
		
							<div>
								<Card.Text className="d-flex align-items-center mb-1">
									<div
										className="bg-aqua card-h5 mr-2"
										style={{
											width: 10,
											height: 10,
											borderRadius: "50%",
										}}
									></div>
									Real
								</Card.Text>
								<p className={`mb-1 ${data.PorcentajeFC < 0 ? 'text-danger' : 'text-success'} text-right`}>{Intl.NumberFormat("en").format(data.M_RealValorizado) }</p>
								<p className={`mb-1 ${data.PorcentajeFC < 0 ? 'text-danger' : 'text-success'} text-right`}>
									{data.PorcentajeReal}%
								</p>
								<p className={`mb-1 ${data.PorcentajeFCAcumulado < 0 ? 'text-danger' : 'text-success'} text-right`}>
									{Intl.NumberFormat("en").format(data.M_RealValorizadoAcumulado)}
								</p>
								<p className={`mb-1 ${data.PorcentajeFCAcumulado < 0 ? 'text-danger' : 'text-success'} text-right`}>{data.PorcentajeRealAcumulado}%</p>
							</div>
		
							<div>
								<h5 className="card-h5">Fa</h5>
								<p className={`mb-1 ${data.PorcentajeFA < 0 ? 'text-danger' : 'text-success'} text-right`}> {Intl.NumberFormat("en").format(data.FA)}</p>
								<p className={`mb-1 ${data.PorcentajeFA < 0 ? 'text-danger' : 'text-success'} text-right`}>{data.PorcentajeFA}%</p>
								<p className={`mb-1 ${data.PorcentajeFAAcumulado < 0 ? 'text-danger' : 'text-success'} text-right`}>{Intl.NumberFormat("en").format(data.FAAcumulado) }</p>
								<p className={`mb-1 ${data.PorcentajeFAAcumulado < 0 ? 'text-danger' : 'text-success'} text-right`}>{data.PorcentajeFAAcumulado}%</p>
							
							</div>
		
							<div>
								<h5>Fc</h5>
								<p className={`mb-1 ${data.PorcentajeFC < 0 ? 'text-danger' : 'text-success'} text-right`}> 
									{Intl.NumberFormat("en").format(data.FC)}
								</p>
								
								<p className={`mb-1 ${data.PorcentajeFC < 0 ? 'text-danger' : 'text-success'} text-right`}>
									{data.PorcentajeFC}%
								</p>
								
								<p className={`mb-1 ${data.PorcentajeFCAcumulado < 0 ? 'text-danger' : 'text-success'} text-right`}>
									{Intl.NumberFormat("en").format(data.FCAcumulado)}
								</p>

								<p className={`mb-1 ${data.PorcentajeFCAcumulado < 0 ? 'text-danger' : 'text-success'} text-right`}>
									{data.PorcentajeFCAcumulado}%
								</p>
							</div>
						</div>
		
						<div className="w-100">
							<div className="progress-group row">
								<div className="col-md-11">
									<div className="progress progress-sm m-2">
										<div
											className="progress-bar bg-blue"
											style={{
												width: `${data.PorcentajeProgramadoAcumulado}%`,
											}}
										></div>
									</div>
								</div>
		
								<div className="col-md-1 p-0">
									<b className="porcentaje-barra">
										{data.PorcentajeProgramadoAcumulado}%
									</b>
								</div>
							</div>
		
							<div className="progress-group row">
								<div className="col-md-11">
									<div className="progress progress-sm m-2">
										<div
											className="progress-bar bg-yellow"
											style={{
												width: `${data.PorcentajeValorizadoAcumulado}%`,
											}}
										></div>
									</div>
								</div>
		
								<div className="col-md-1 p-0 ">
									<b className="porcentaje-barra">
										{" "}
										{data.PorcentajeValorizadoAcumulado}%
									</b>
								</div>
							</div>
		
							<div className="progress-group row">
								<div className="col-md-11">
									<div className="progress progress-sm m-2">
										<div
											className="progress-bar bg-aqua"
											style={{
												width: `${data.PorcentajeRealAcumulado}%`,
											}}
										></div>
									</div>
								</div>
		
								<div className="col-md-1 p-0">
									<b className="porcentaje-barra">
										{" "}
										{data.PorcentajeRealAcumulado}%
									</b>
								</div>
							</div>
						</div>
					</Card.Body>
					</Card>

				</div>
				))}
				{selectedOption > 0 && selectedData.CodPeriodo && (
					<ResourceList 
						resources={proyects.monthResources.items}
						loading={proyects.loadingResources}
						hasMore={hasMore}
						loadMore={loadMoreResources}
						totalItems={totalItems}
						currentPage={currentPageRef.current}
						onSearch={handleSearch}
						accumulated={accumulatedRef.current}
					/>
				)}
			</>
		)}
		</>
	);
};

export default CardsHistory;